
import React, { useReducer } from "react";
import axios2 from 'services/axios2';

import {useParams} from "react-router-dom";
import {Link,hashHistory} from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';

import FigureItem  from "components/FigureItem";

import { withRouterJim } from "router/withRouterJim";

//--- CONTEXT API -----------
import { useStore, useDispatch, StoreContext } from "store/StoreProvider";
import {types, storeReducer} from "store/StoreReducer"


import { NotificationContainer, NotificationManager } from 'react-notifications';
import {
  Table,
  Button,
  Container,
  Modal,
  ModalHeader,
  ModalBody,
  FormGroup,
  ModalFooter,
  ToastHeader,
} from "reactstrap";


const initialForm = {
  idd:0,
  ope:'n',
  
  
  promedio_tareas:0,

};

//$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$
class NotasEst extends React.Component {
  state = {

    modalImagen: false,
        
    form: Object.assign({}, initialForm),
  
    
    data: [],/* lista  */
    collection:[],
   
    
  };
   //---------------- CONTEXT API ------------------
    //const store = useStore();
    

  //---------------------------------
  componentDidMount() {
    //--limpiamos el array de prueba
    this.setState({data:[]});
    
    this.cargar_data();

    const date = new Date();
    const defaultValue = date.toLocaleDateString('en-CA');
  
    
  }
  //----------------especial, actualiza valores del form -------------------------------
  handleChangeForm = (e) => {
    //requerimos la prop name='?' en cada control
    
    //--- esto lo hacemos porque en vez de utilizar valores true, false
    //--- tenemos que utilizar 1, 0
    if(e.target.type==="checkbox"){

      let res = e.target.checked? 1:0;        
      this.setState({
        form:{
          ...this.state.form,
          [e.target.name]: res,
        }
      })
    }else{
      this.setState({
        form: {
          ...this.state.form,
          [e.target.name]: e.target.value,
        },
      });
    }
  };
  //-------------------------------------------
  /*
    "id_mate": 20,
  
   */
  cargar_data=()=>{
    console.log("cargar_data")
    let id_est = this.props.store.user.id_est;
    let id_mate = this.props.store.materia.id_mate;
    let id_peri = this.props.store.user.id_peri;
    //let periodo = this.props.store.user.periodo;

    let param = { 
      id_est: id_est,
      id_mate: id_mate,
      id_peri: id_peri,
    }
    console.log(param)
    axios2.post("notas_est_get_list", param)
    .then(res => {
        console.log(res.data)

        if(res.data != null ){ 
            this.setState({ data: res.data.data });
            this.setState({ collection: res.data.collection });
            this.setState({ form: res.data.form });
            //this.setState({ promedio_tareas: res.data.promedio_tareas });
        }else{
            this.setState({ form: Object.assign({}, initialForm), });
            NotificationManager.error('No existen datos');
        }
    }).catch(error => {
        alert("---- Existio un error ---");
        console.log(error);
    });
  }
  //-----------------------------------------
  // retorna id_mate, nombre, sigla
  onClickArticle=(item)=>{
    console.log("onClickArticle");
    console.log(item)
    //guardamos el usuario en el localstorage
    //localStorage.setItem("materia", JSON.stringify(item));
    //---------- lo colocamos a el STORE ------------------ 
    let materia = { id_mate:item.id_mate, nombre: item.nombre, sigla: item.sigla ,grupo: item.id_grupo, foto: item.foto }
    this.props.dispatch({ type: types.setMateria, payload: materia }); 
    //dispatch({type: types.authLogin, payload: response.user}); 
    //----------  -----------------------------------------

    let ruta = `/curso_main/${item.id_mate}`;
    //--redireccionamos
    this.props.navigate(ruta);

  }
  //------------------------------
  render() {
    let nom_mate = this.state.nom_mate
    let id_mate= this.state.id_mate
    let promedio_asistencias = this.state.promedio_asistencias;

    let nro =0;
    let form = this.state.form
    let bimestre1 = this.state.bimestre1
    let bimestre2 = this.state.bimestre2
    let bimestre3 = this.state.bimestre3
    let bimestre4 = this.state.bimestre4

    return(
      <section className="container">
        {
          //JSON.stringify(this.state.data)
        }

        <h5 className="titulo3">Mis calificaciones</h5>


        <div className="table-responsive">

          <div className="table-wrapper">
            <div className="table-title"><b>Examenes</b></div>  
          

            <table className="table table-striped table-hover">
              <thead>
                <tr>
                  <th>Título</th>
                  <th>Nota</th>
                  <th>Comentario</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody>
                
                {this.state.data.map((item,index) => ( 
                <tr key={index}>
                  <td>{ item.titulo }</td>
                  <td>{ item.nota }</td>
                  <td>{ item.comentario }</td>
                  <td>

                    <a href="estu_revisa_examen/{{$id_exaest}}" className="edit-modal btn btn-warning ">
                      { item.permiteverexa_sn===1 &&
                        <i className="fa fa-lock"></i>
                      }
                      Ver examen
                    </a>
                  </td>
                </tr>
                ))}

              </tbody>
            </table>
            </div>
          </div>

        
        {/*<!--     ----------------------------------------------------------------------    -->*/ }
        <div className="table-wrapper">
          <div className="table-title"><b>Tareas</b>
          </div>
          <table className="table d table-bordered">
            <thead>
              <tr>
                <th>Nro</th>
                <th>titulo</th>
                <th>Nota</th>
                <th>Comentario</th>
              </tr>
            </thead>
            <tbody>
              {this.state.collection.map((item,index) => ( 
              <tr key={index}>
                <td>{ index+1 }</td>
                <td>{ item.titulo }</td>
                <td>{ item.nota }</td>
                <td>{ item.comentario }</td>
                
              </tr>
              ))}
            </tbody>
            <tfoot style={{ backgroundColor: '#ccc' }}>
              <tr>
                <td></td>
                <td colSpan={3} ><b>Nota ponderada sobre 10pts= { this.state.form.promedio_tareas } Puntos</b></td>
              </tr>
            </tfoot>
          </table>
        </div>
      </section >
    )
  }
}

//------------para que soporte la funcionalidad de parametros
export default withRouterJim(NotasEst);